import { render, staticRenderFns } from "./FieldTextList.vue?vue&type=template&id=869e16b2&scoped=true"
import script from "./FieldTextList.vue?vue&type=script&lang=js"
export * from "./FieldTextList.vue?vue&type=script&lang=js"
import style0 from "./FieldTextList.vue?vue&type=style&index=0&id=869e16b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869e16b2",
  null
  
)

export default component.exports